module.exports = __webpack_public_path__ + "img/welcome-image-1.37a5a75e.jpg";